import { A1_itemType, A1_selectType } from "@/types";

// 初始化状态
const initState = {
  // 列表
  list: [] as A1_itemType[],
  // 总条数
  total: 0,
  // 下拉数据
  select: {
    type: [],
    age: [],
  } as A1_selectType,
};

// 定义 action 类型
type Props =
  | { type: "home/setList"; payload: A1_itemType[] }
  | { type: "home/setSelect"; payload: A1_selectType }
  | { type: "home/setTotal"; payload: number };
// 频道 reducer
export default function loginReducer(state = initState, action: Props) {
  switch (action.type) {
    // 列表
    case "home/setList":
      return { ...state, list: action.payload };
    // 下拉数据
    case "home/setSelect":
      return { ...state, select: action.payload };
    // 总条数
    case "home/setTotal":
      return { ...state, total: action.payload };

    default:
      return state;
  }
}
